<template>
    <div class="" id="panel">
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="ml-3">Filters</h5>
              <span class="btn btn-link" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                  <div class="col-md-6 col-lg-2">
                      <label for="filter" class="">From</label>
                      <datepicker :disabledDates="disabledDates" v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-6 col-lg-2">
                      <label for="filter" class="">To</label>
                      <datepicker :disabledDates="disabledDates" v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <button @click="clear()" type="button" class="btn btn-secondary rounded mt-4">Clear</button>
                    <button @click="getSavedFiltersHistory()" type="button" class="btn btn-primary rounded mt-4">Filter</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="abs-btn-grp">
            <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
              <i @click="search()"  class="fas fa-search active cursor-pointer mt-0" aria-hidden="true"></i>
              <input v-on:keyup.enter="search" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search" aria-label="Search">
              <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer mt-0"></i>
            </form>
          </div>
            <div class="row xsOnly">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                              <th 
                                scope="col" 
                                class="sort text-left"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'createdDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'createdDate'  ? 'sort-desc' : '']"  
                                @click="sort('createdDate')"
                              >date</th>
                              <th
                                scope="col" 
                                class="sort text-left"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'name'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'name'  ? 'sort-desc' : '']"  
                                @click="sort('name')">Name</th>
                              
                                <th
                                scope="col" 
                                class="sort text-right"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'matchedCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'matchedCount'  ? 'sort-desc' : '']"  
                                @click="sort('matchedCount')">Bid wanted Hit count 
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="Number Bid wanteds hitting the strategy.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span>
                              </th>
                                <th
                                scope="col" 
                                class="sort text-right"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'suggestedPriceCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'suggestedPriceCount'  ? 'sort-desc' : '']"  
                                @click="sort('suggestedPriceCount')">Suggested
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="Number of Bids suggested with the strategy.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span>
                              </th>
                                <th
                                scope="col" 
                                class="sort text-right"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'failedCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'failedCount'  ? 'sort-desc' : '']"  
                                @click="sort('failedCount')">Failed
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="Number of Bid wanteds for which price suggestion failed after hitting the strategy.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span>
                              </th>
                                <th
                                scope="col" 
                                class="sort text-right"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bidCount'  ? 'sort-desc' : '']"  
                                @click="sort('bidCount')">Bid Count
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="Number of bids sent with the strategy.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span>
                              </th>
                              <th
                                scope="col" 
                                class="sort text-right"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'newCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'newCount'  ? 'sort-desc' : '']"  
                                @click="sort('newCount')">REJECTED 
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="The number of suggested bids that have not yet been sent.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span>
                              </th>
                                <th
                                scope="col" 
                                class="sort text-right"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'executedCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'executedCount'  ? 'sort-desc' : '']"  
                                @click="sort('executedCount')">Executed Count
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="The number of bids executed among those hit this strategy.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span>
                              </th>  
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="savedFiltersHistory.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in savedFiltersHistory" :key="data.id">
                              <td class="text-left">{{data.createdDate ? moment(data.createdDate).format("MM/DD/YYYY") : 'N/A'}}</td>
                              <td class="text-left">{{data.name}}</td>
                              <td class="text-right">{{data.matchedCount}}</td>
                              <td class="text-right">{{data.suggestedPriceCount}}</td>
                              <td class="text-right">{{data.failedCount}}</td>
                              <td class="text-right">{{data.bidCount}}</td>
                              <td class="text-right">{{data.newCount}}</td>
                              <td class="text-right">{{data.executedCount}}</td>
                             
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getSavedFiltersHistory(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>    
    
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsCusipComponent",
  components : {
    Datepicker
  },
  data() {
    return {
        loading : false,
        currentPage: 1,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "id",
        sortOrder: "DESC",
        savedFiltersHistory : [],
        showAddFilterModal : false,
        selectedFilter : null,
        isSearchOnly : false,
        showFilters : false,
        fromDate : "",
        toDate : "",
        disabledDates: {
            from: new Date(new Date() - 86400000)
        }

    };
  },
  methods: {
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getSavedFiltersHistory();
    },
    clear(){
      this.fromDate = this.moment().subtract(1,'days').format("MM-DD-YYYY"); 
      this.toDate = this.moment().format("MM-DD-YYYY");
      this.getSavedFiltersHistory();
    },
    search(){
        this.currentPage = 1;
        this.getSavedFiltersHistory();  
    },
    clearSearch(){
        this.searchValue = "";
        this.currentPage = 1;
        this.getSavedFiltersHistory();  
    },
    getSavedFiltersHistory(){
      //page=1&size=10&search=&sortColumn=id&sortOrder=ASC&fromDate=2024-02-01%2005:00:00&toDate=2024-02-15%2005:00:00&userId=154
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        var fDate = this.fromDate ? this.moment(this.fromDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
        var tDate = this.toDate ?  this.moment(this.toDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/autobidder/bid-count-log-strategy?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&userId="+
            authService.getUser().id+
            "&fromDate="+
            fDate+
            "&toDate="+
            tDate,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.savedFiltersHistory = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    }
  },
  mounted() {
    this.fromDate = this.moment().subtract(1, 'days').format("MM-DD-YYYY");
    this.toDate = this.moment().format("MM-DD-YYYY"); 
    this.getSavedFiltersHistory()
  }
};
</script>

<style scoped>
button.btn-danger{
  min-width: 0;
}
</style>